<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper d-block d-print-block">
    <div class="m-content">
      <transition name="slide" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content',
};
</script>

<style></style>
